import { WorkflowNode } from 'api/model.ts';
import { useMemo } from 'react';
import useRevisedWorkflows from './useRevisedWorkflows';

type Options = {
  nodes?: WorkflowNode[];
};

const useRevisedWorkflowsFromNodes = ({ nodes }: Options) => {
  const workflowRevisions = useMemo(() => {
    const uniqueRevisions = new Set();
    return nodes
      ?.filter((node) => {
        const key = `${node.workflow_id}-${node.workflow_revision}`;
        if (uniqueRevisions.has(key)) {
          return false;
        } else {
          uniqueRevisions.add(key);
          return true;
        }
      })
      .map((node) => ({ workflow_id: node.workflow_id, revision: node.workflow_revision }));
  }, [nodes]);

  return useRevisedWorkflows({ revisedWorkflows: workflowRevisions });
};

export default useRevisedWorkflowsFromNodes;
